export const PIP_MODES = {
  ALWAYS: 'always',
  CALLS_ONLY: 'calls-only',
} as const;

export const PIP_EVENTS = {
  OPEN_FLOATING: 'pip:open-floating',
  OPEN_OUTBOUND_CALL: 'pip:open-outbound-call',
  OPEN_TRANSFER: 'pip:open-transfer',
} as const;

export const PIP_STORAGE_KEYS = {
  MODE: 'pip-mode',
  ENABLED: 'pip-enabled',
} as const;
